module.exports = new __parcel__URL__("beetlejuice-decoration-top-left.2c87c39d.svg").toString();